var _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 25,
    transform: "scale(-1)",
    cx: -34,
    cy: -34,
    fill: "#000000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "m 34,59 c 3.283,0 6.5339,-0.6466 9.5671,-1.903 3.0331,-1.2564 5.7891,-3.0979 8.1106,-5.4193 2.3214,-2.3215 4.1629,-5.0775 5.4193,-8.1106 C 58.3534,40.5339 59,37.283 59,34 H 34 Z",
    fill: "#000000",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -34,
    cy: 34,
    r: 4,
    transform: "rotate(-90)",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 34,59 C 40.6304,59 46.9893,56.3661 51.6777,51.6777 56.3661,46.9893 59,40.6304 59,34",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 34.9365,52.0001 -4.9341,6.575 4.9292,6.5636",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight90);
export default __webpack_public_path__ + "static/media/Right90.8e2c78514e291b60a3620fe246c68ab7.svg";
export { ForwardRef as ReactComponent };